import s from "./HealthlinkSubmissionStatus.module.css";

const Field = ({ label, value }) => {
  if (!value) return null;

  return (
    <div className={s.field}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{value}</span>
    </div>
  );
};

// Where a Healthlink submission stands, in the shape the CDM review preview ends on:
// status, when it went, and the message reference. Shared by the eLab order detail and
// the referral detail, because it is the same question about the same kind of thing —
// and the two answering it differently would be the confusing part.
//
// The status pill is passed in rather than derived: each flow has its own statuses and
// its own colours, and this component has no business knowing either. Everything else
// renders only when supplied, so a flow that has no acknowledgement code simply omits it.
export const HealthlinkSubmissionStatus = ({
  statusPill,
  submitted,
  lastUpdate,
  acknowledgement,
  messageId,
  messageIdLabel = "Message ID:",
}) => {
  const hasAnything =
    !!statusPill || !!submitted || !!lastUpdate || !!acknowledgement || !!messageId;

  if (!hasAnything) return null;

  return (
    <section className={s.section}>
      <h4 className={s.header}>Healthlink Submission Status</h4>
      <div className={s.grid}>
        {!!statusPill && (
          <div className={s.field}>
            <span className={s.label}>Status:</span>
            {statusPill}
          </div>
        )}
        <Field label="Submitted:" value={submitted} />
        <Field label="Acknowledgement:" value={acknowledgement} />
        <Field label="Last update:" value={lastUpdate} />
      </div>
      {!!messageId && (
        <div className={s.messageIdRow}>
          <span className={s.label}>{messageIdLabel}</span>
          <span className={s.messageIdValue}>{messageId}</span>
        </div>
      )}
    </section>
  );
};
